const ACTION_SCOPE = "[Session]";

export class SetSession {
  static readonly type = `${ACTION_SCOPE} Set Session`;
  constructor(
    public ssoToken: string,
    public refreshToken: string,
    public expiresInSeconds: number
  ) {}
}

export class ClearSession {
  static readonly type = `${ACTION_SCOPE} Clear Session`;
}
